module.exports = __webpack_public_path__ + "static/img/contant_5.55d139b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/contant_5.png
// module id = J32h
// module chunks = 0